(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var activePreview = null;
  var frameCache = new Map();
  var hoverDelay = 100;
  var frameDelay = 140;

  function sizedFrame(source) {
    try {
      var url = new URL(source, window.location.href);
      if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '480');
      return url.toString();
    } catch (_) {
      return source;
    }
  }

  function restore(preview) {
    if (!preview) return;
    window.clearTimeout(preview.delayTimer);
    window.clearInterval(preview.frameTimer);
    preview.token += 1;
    preview.image.src = preview.originalSrc;
    if (preview.originalSrcset === null) preview.image.removeAttribute('srcset');
    else preview.image.setAttribute('srcset', preview.originalSrcset);
    if (preview.originalSizes === null) preview.image.removeAttribute('sizes');
    else preview.image.setAttribute('sizes', preview.originalSizes);
    preview.media.classList.remove('is-spinning', 'is-spin-loading');
    if (activePreview === preview) activePreview = null;
  }

  function loadFrame(source) {
    if (frameCache.has(source)) return frameCache.get(source);
    var promise = new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () {
        if (image.decode) image.decode().catch(function () {}).finally(resolve);
        else resolve();
      };
      image.onerror = reject;
      image.src = source;
    });
    frameCache.set(source, promise);
    promise.catch(function () { frameCache.delete(source); });
    return promise;
  }

  function begin(media) {
    var image = media.querySelector('[data-material-spin-preview]');
    if (!image) return;
    var frames;
    try { frames = JSON.parse(image.dataset.spinFrames).map(sizedFrame); }
    catch (_) { return; }
    if (frames.length < 2) return;

    if (reducedMotion.matches) {
      if (!image.dataset.spinOriginalSrc) image.dataset.spinOriginalSrc = image.currentSrc || image.src;
      image.removeAttribute('srcset');
      image.src = frames[1];
      return;
    }

    if (activePreview) restore(activePreview);
    var preview = {
      media: media,
      image: image,
      frames: frames,
      originalSrc: image.currentSrc || image.src,
      originalSrcset: image.getAttribute('srcset'),
      originalSizes: image.getAttribute('sizes'),
      delayTimer: 0,
      frameTimer: 0,
      token: 0
    };
    activePreview = preview;
    preview.delayTimer = window.setTimeout(function () {
      var token = ++preview.token;
      media.classList.add('is-spin-loading');
      var pendingFrames = frames.map(loadFrame);

      pendingFrames[1].then(function () {
        if (activePreview !== preview || preview.token !== token) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        media.classList.remove('is-spin-loading');
        media.classList.add('is-spinning');

        function showNext(index) {
          if (activePreview !== preview || preview.token !== token) {
            preview.frameTimer = 0;
            return;
          }
          if (index >= frames.length) index = 0;
          pendingFrames[index].then(function () {
            if (activePreview !== preview || preview.token !== token) return;
            image.src = frames[index];
            preview.frameTimer = window.setTimeout(function () { showNext(index + 1); }, frameDelay);
          }).catch(function () {
            if (activePreview === preview) restore(preview);
          });
        }

        showNext(1);
      }).catch(function () {
        if (activePreview === preview) restore(preview);
      });
    }, hoverDelay);
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest('.ll-material-card');
    if (!card || card.contains(event.relatedTarget)) return;
    var media = card.querySelector('.ll-material-card__media');
    if (!media) return;
    begin(media);
  });

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest('.ll-material-card');
    if (!card || card.contains(event.relatedTarget)) return;
    var media = card.querySelector('.ll-material-card__media');
    if (!media) return;
    var image = media.querySelector('[data-material-spin-preview]');
    if (image && image.dataset.spinOriginalSrc) {
      image.src = image.dataset.spinOriginalSrc;
      delete image.dataset.spinOriginalSrc;
    }
    if (activePreview && activePreview.media === media) restore(activePreview);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && activePreview) restore(activePreview);
  });

  function warmPreview(image) {
    var frames;
    try { frames = JSON.parse(image.dataset.spinFrames).map(sizedFrame); }
    catch (_) { return; }
    frames.slice(1).forEach(loadFrame);
  }

  function warmVisiblePreviews() {
    var images = document.querySelectorAll('[data-material-spin-preview]');
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        warmPreview(entry.target);
      });
    }, { rootMargin: '240px' });
    images.forEach(function (image) { observer.observe(image); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warmVisiblePreviews, { once: true });
  } else {
    warmVisiblePreviews();
  }
})();
